import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { EMPTY, from, Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { DraftService } from "./draft.service";
import { InternalAppService } from "src/services/app.service";

@Injectable({
    providedIn: 'root',
})
export class DraftResolver implements Resolve<unknown> {

    constructor(
        private draftService: DraftService,
        private appService: InternalAppService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): unknown | Observable<unknown> | Promise<unknown> {
        return from(this.draftService.initDraft(route)).pipe(
            tap(x => console.log('### R tap:', x)),
            catchError(x => {
                this.appService.__addResolverException(route.outlet, x);
                console.error('### R error:', x); return EMPTY;
            })
        );
    }

}
